module.exports = __webpack_public_path__ + "img/Gruppenführer_Ltr_FK.bcfa96ce.svg";